import { Components } from '@mui/material/styles';

/** Height of a themed outlined input. Exported so controls placed beside one can match it. */
export const INPUT_HEIGHT = '60px';

const MuiOutlinedInput: Components = {
  MuiOutlinedInput: {
    styleOverrides: {
      root: {
        '.MuiOutlinedInput-input': {
          background: '#ffffff',
          border: '0.5px solid #e0e0e0',
          boxShadow: '0px 0px 29px rgba(0, 0, 0, 0.05)',
          borderRadius: '10px !important',
          height: INPUT_HEIGHT,
          lineHeight: INPUT_HEIGHT,
          padding: '0 20px',
          boxSizing: 'border-box',
          fontSize: '18px',
          color: 'black',
        },
        // A select draws its arrow inside the box, so it needs the right-hand room
        // MUI normally reserves - the flat `padding` above would let the value run
        // underneath the arrow. Two classes to outrank that single-class rule.
        '.MuiSelect-select.MuiOutlinedInput-input': {
          paddingRight: '44px',
        },
        '.MuiOutlinedInput-notchedOutline': {
          border: 0,
        },
      },
    },
  },
};

export default MuiOutlinedInput;
